import { DataType, VariableType } from '@mode-vegas/vegas';

import { TreeNode, treeNodeFactory } from '../../lib/tree-node';
import { ReportFilterFieldType, ReportFilterFieldTypes } from '@mode/filters/util';

export default class FieldTreeViewController {
  static $inject = [];

  private treeNodes: TreeNode[];
  private fields: ReportFilterFieldTypes[];
  private onSelect: ($args: { $id: any }) => void;

  constructor() {}

  $onChanges(changed) {
    if (changed.fields) {
      this.updateTreeNodes(this.fields);
    }
  }

  handleSelection($id) {
    this.onSelect({ $id });
  }

  updateTreeNodes(fields = []) {
    if (fields.length) {
      this.treeNodes = fieldsToTreeNodes(fields);
    }
  }
}

function fieldsToTreeNodes(fields: ReportFilterFieldTypes[]): TreeNode[] {
  return fields.map(fieldToTreeNode);
}

function fieldToTreeNode(field: ReportFilterFieldTypes) {
  let nodes = [];
  let props = {};

  const { name, id: key } = field;
  let disabled = false;
  let icon = null;

  switch (field.type) {
    case ReportFilterFieldType.Field:
      disabled = field.inUse || field.isAggregate;

      props = {
        type: field.control.filterType,
      };

      const { varType, dataType } = field.control;
      let typeIcon = dataTypeIcon(dataType);
      if (varType === VariableType.DISCRETE && typeIcon === 'date') {
        typeIcon = 'number';
      }
      icon = `icon-${varType.toLowerCase()}-${typeIcon}`;
      break;
    case ReportFilterFieldType.Folder:
      nodes = fieldsToTreeNodes(field.fields);
      break;
  }

  return treeNodeFactory(key, name, props, nodes, icon, disabled);
}

function dataTypeIcon(dataType) {
  switch (dataType) {
    case DataType.BOOLEAN:
      return 'number';
    case DataType.INTEGER:
      return 'number';
    case DataType.FLOAT:
      return 'number';
    case DataType.DATE:
      return 'date';
    case DataType.DATETIME:
      return 'date';
    case DataType.DATEWKDAY:
      return 'number';
    case DataType.DATEMONTH:
      return 'number';
    case DataType.DATEQTR:
      return 'number';
    case DataType.STRING:
      return 'text';
  }
}
